import './styles/base.scss'
import './styles/widget.scss'
import './styles/part.scss'

import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import routes from './routes'
// import store from './store'
import * as api from './api'
import globalState from './globalState'
import { routerBase } from '@/globals'

Vue.config.productionTip = false

let createRouter = () => {
  let router = new Router({
    routes,
    base: routerBase
  })
  router.beforeEach((to, from, next) => {
    if (globalState.auth) {
      let app = router.app as App
      if (app.isModal) {
        next(false)
      }
      else {
        next()
      }
    }
    else {
      if (to.path == '/login') {
        next()
      }
      else {
        next({path: '/login', query: {returnUrl: to.fullPath}})
      }
    }
  })
  router.afterEach((to, from) => {
    let app = router.app as App
    if (app.$data)
      app.showMenu = false
  })
  router.beforeEach((to, from, next) => {
    let app = router.app as App
    if (app.isModal) {
      next(false)
    }
    else {
      next()
    }
  })
  router.afterEach((to, from) => {
    let app = router.app as App
    if (app.$data)
      app.showMenu = false
  })
  return router
}


let init = async () => {
  if (process.env.NODE_ENV === 'development' || window['__next_blend_enabled__'] === true) {
    let blend = (await import(/* webpackChunkName: "blend" */ './blend')).default
    await blend(routes)
  }
  let router = createRouter()
  new Vue({
    router,
    // store,
    render: h => h(App)
  }).$mount('#app')
}

init()


// let app = new App();
// app.$mount('#app')

